<template>
  <div>
    <el-input :placeholder="placeholder" v-model="innerValue" class="input-with-select" :disabled="disabled">
      <el-button slot="append" icon="el-icon-folder" type="success" @click="handleOpenMenu"></el-button>
    </el-input>
  </div>
</template>

<script>
/**
 * 文件夹路径选择器
 * @author PeterLee
 * @since 2023-01-31
 */
export default {
  name: "DirectorySelect",
  //设置v-model绑定对象和自动更新响应方法
  model: {
    prop: 'path',
    event: 'change',
  },
  props: {
    path: String,
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请输入内容"
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.path;
      },
      set(val) {
        this.$emit('change', val);
      }
    }
  },
  methods: {
    handleOpenMenu () {
      //浏览器运行提示(非electron运行)
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('electron/') === -1) {
        this.$message.error("提示：浏览器无法选择对应系统目录，请下载客户端后使用该功能！")
        return;
      }
      const path = window.appApi.selectDirectory()
      if (path) {
        this.$emit("change", path)
      }
    }
  }
}
</script>

<style scoped>

</style>